/** Signing in: a quiet centred card, always light. */
import { useState, type FormEvent } from 'react';
import { useAuth } from '../lib/auth.tsx';
import { ApiError } from '../lib/api.ts';
import { AlertIcon, Logo } from '../components/icons.tsx';
import { Button, Field, inputClass } from '../components/ui.tsx';
import { Surface } from '../design/primitives.tsx';

export function LoginPage() {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string>();
  const [busy, setBusy] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(undefined);
    try {
      await login(email, password);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Login failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-theme="light" className="min-h-screen bg-n1 text-n10 font-sans text-body grid place-items-center px-4 py-10">
      <form onSubmit={(e) => void submit(e)} className="w-full max-w-[380px] flex flex-col gap-7 mv-pop">
        <div className="flex flex-col items-center gap-3 text-center">
          <Logo />
          <h1 className="m-0 text-title font-semibold tracking-tight">MessageVault</h1>
          <p className="m-0 text-small text-n8">Search anything. See where it went.</p>
        </div>
        <Surface level={2} className="p-6 flex flex-col gap-4">
          {error && <p role="alert" className="m-0 flex items-center gap-2 text-small text-fail"><AlertIcon size={16} className="shrink-0" />{error}</p>}
          <Field label="Email">
            <input className={inputClass} type="email" autoComplete="username" required autoFocus value={email} onChange={(e) => setEmail(e.target.value)} />
          </Field>
          <Field label="Password">
            <input className={inputClass} type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} />
          </Field>
          <Button type="submit" variant="primary" disabled={busy} className="h-10 mt-1 font-semibold">{busy ? 'Signing in…' : 'Sign in'}</Button>
        </Surface>
      </form>
    </div>
  );
}
